import React from 'react';
import { Button, ButtonProps, Checkbox, message, Modal } from 'antd';
import s from './s.module.less';
import useGoogleCategory from 'hooks/useGoogleCategory';
import { TGoogleCategory } from 'types/google';
import { isValidEmail } from 'utils/form';
import { subscribeGoogleCategory } from 'api/google';

type Props = ButtonProps & {
    show: boolean,
    onClose: () => void,
};

enum ESyncType {
    SUNNY_PRACTICE = 'Sunny practice',
    THERAPY_WORK_SCHEDULE = 'Therapy work schedule',
    PERSONAL_EVENTS = 'Personal Events',
    TEAM_MEETINGS = 'Team Meetings',
}

const GoogleAuthCalendarSetting = (props: Props) => {
    const { show, onClose } = props;
    const [values, setValues] = React.useState<string[]>([]);
    const [googleCategory, googleCategoryLoading, fetchGoogleCategory] = useGoogleCategory();
    const [submitLoading, setSubmitLoading] = React.useState(false);

    React.useEffect(() => {
        if (googleCategory && googleCategory.length > 0) {
            setValues(googleCategory.filter((item: TGoogleCategory) => item.selected || item.primary).map((item: TGoogleCategory) => item.id));
        }
    }, [googleCategory]);

    const handleSave = async () => {
        setSubmitLoading(true);
        const res = await subscribeGoogleCategory(values);
        if (!res.error) {
            message.success('Updated successfully');
            onClose();
        }
        setSubmitLoading(false);
    };

    return (
        <Modal
            open={show}
            width={540}
            onCancel={() => {
                onClose();
            }}
            title="Choose calendars to sync from Google"
            okText="Save"
            onOk={handleSave}
            destroyOnClose
            okButtonProps={{
                loading: submitLoading,
            }}
        >
            <div className={s.wrap}>
                <div className={s.title}>You’ve connected your primary calendar. Select any additional calendars you’d like to sync.</div>
                <div className={s.tips}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55229 6.44772 9 7 9V12C7 12.5523 7.44772 13 8 13H9C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11V8C9 7.44772 8.55228 7 8 7H7Z" fill="#60A5FA" />
                    </svg>
                    <p>
                        Syncing multiple calendars helps you view all your events in one place, making scheduling more efficient.
                    </p>
                </div>
                <div className={s.selectWrap}>
                    <Checkbox.Group
                        style={{ width: '100%' }}
                        onChange={(val) => {
                            setValues(val as string[]);
                        }}
                        value={values}
                    >{
                            googleCategory?.map((item: TGoogleCategory) => {
                                let label = item.summary;
                                if (label && isValidEmail(label)) {
                                    if (item.primary) {
                                        label = `${label}'s calendar (Primary)`;
                                    } else {
                                        label = `${label}'s calendar`;
                                    }
                                }
                                return (
                                    <Checkbox
                                        value={item.id}
                                        disabled={!!item.primary}
                                    >
                                        <div className={s.item}>
                                            {label}
                                            {
                                                item.primary &&
                                                <span className={s.tag}>{label}</span>
                                            }
                                        </div>
                                    </Checkbox>
                                );
                            })
                        }
                    </Checkbox.Group>
                </div>
            </div>

        </Modal>
    );
};

export default GoogleAuthCalendarSetting;
